import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IDownloadStrategy} from '@igp/shared/redux/download';
import type {IEntityReadService} from '@igp/shared/redux/entity';
import type {EntityType} from '@models';

import {agentLevelReportV2ServiceTypes} from './constants';
import {AgentLevelReportV2DownloadClientStrategy, AgentLevelReportV2DownloadServerStrategy} from './downloadStrategy';
import {AgentLevelReportV2Service} from './service';
import type {AgentLevelReportV2ViewModelsKeys} from './types';

export class AgentLevelReportV2ContainerFacade extends ContainerFacade {
    bindAll() {
        this._container.bind<IEntityReadService<EntityType>>(agentLevelReportV2ServiceTypes.service).to(AgentLevelReportV2Service);
        this._container
            .bind<IDownloadStrategy<AgentLevelReportV2ViewModelsKeys>>(agentLevelReportV2ServiceTypes.downloadClientStrategy)
            .to(AgentLevelReportV2DownloadClientStrategy);
        this._container
            .bind<IDownloadStrategy<AgentLevelReportV2ViewModelsKeys>>(agentLevelReportV2ServiceTypes.downloadServerStrategy)
            .to(AgentLevelReportV2DownloadServerStrategy);
    }
}
